import FormatListBulletedTwoToneIcon from '@mui/icons-material/FormatListBulletedTwoTone';
import { useState } from 'react';
import { useSelector } from 'react-redux';
import { Button, Box } from '@mui/material';
import ImportExportIcon from '@mui/icons-material/ImportExport';
import Swal from 'sweetalert2';
import strings from '../Globalization/index';
import Model from '../models/model';
import ActionIconButton from '../components/common/ActionIconButton';
import Connection from '../services/Connection';
import util from '../util';
import LoadingDialog from '../components/common/LoadingDialog';

const sterisAdminRole = 'steris admin';
const { showError } = util;
const xlsxFileExtension = '.xlsx';


const ImportButton = (params) => {
	const [loading, setLoading] = useState(false);
	const currentRole = useSelector(storeState => storeState.auth.tags.RoleName);
	const handleFileChange = async (e) => {
		const file = e.target.files[0];
		e.target.value = '';
		if (!file) return;

		if (!file.name.endsWith(xlsxFileExtension)) {
			showError(strings.FileValidation, strings.Error, 'error');
			return;
		}
		try {
			await uploadFile(file);
		} catch (err) {
			console.error(err);
			showError(strings.LanguageImportFailed, strings.Error, 'error');
		}
		params?.onRefresh();
	};

	const uploadFile = async (file) => {
		const formData = new FormData();
		formData.append("file", file);
		formData.append("action", 'otherAction');
		formData.append("otherAction", 'HandleImportFile');
		setLoading(true);
		try {
			const response = await fetch(Connection.Language, {
				method: 'POST',
				body: formData
			});
			const { success, info, data } = await response.json();
			if (success) {
				Swal.fire({
					icon: 'success',
					title: strings.Success,
					text: strings.LanguageImportSuccess,
					confirmButtonText: strings.Ok,
					allowOutsideClick: false
				});
			}
			if (info) {
				let extraInfo = "";
				if (data) {
					extraInfo = data.rowNumber ? `\n ${strings.RowNumber}: "${data.rowNumber}"` : '';
					extraInfo = data.columnName && extraInfo + `\n ${strings.ColumnName}: "${data.columnName}"`;
				}
				Swal.fire({
					title: strings.Error,
					html: `${strings[info] || info} <pre> ${extraInfo}</pre>`,
					icon: 'error',
					confirmButtonText: strings.Ok,
					allowOutsideClick: false
				});
			}
		} catch (err) {
			console.error(err);
			showError(strings.LanguageImportFailed, strings.Error, 'error');
		} finally { setLoading(false) }
	};
	
	return sterisAdminRole === currentRole.toLowerCase() && (
		<Box>
			<LoadingDialog open={loading} />
			<label htmlFor="upload-file">
				<Button
					variant="contained"
					component="span"
					sx={{ padding: '0px 18px', height: '30px' }}
					startIcon={<ImportExportIcon />}
					onClick={() => {
						Swal.fire({
							title: "Info",
							text: strings.languageKeyRestrictions,
							icon: "info",
							confirmButtonText: strings.Ok,
							allowOutsideClick: false
						}).then(({ isConfirmed }) => {
							if (isConfirmed) {
								document.getElementById('upload').click()
							}
						});
					}}
				>
					{strings.Import}
				</Button>
			</label>
			<input type="file" id="upload" accept=".xlsx" onChange={handleFileChange} style={{ display: 'none' }} />
		</Box >
	)
}

const model = new Model({
	name: 'LanguageDetail',
	title: 'LanguageMapper',
	listTitle: 'LanguageMapper',
	defaultSort: 'LanguageName',
	disableDelete: true,
	disableAdd: true,
	formTitleField: 'LanguageKey',
	headerFilterApplyTrigger: 'onChange',
	gridTitle: 'LanguageMapper',
	idProperty: '_id',
	showGridRefreshBtn: true,
	gridToolbarCustomActions: [
		{
			Component: ImportButton,
		}
	],

	columns: [
		{
			header: 'Language',
			field: 'LanguageName',
			formField: 'LanguageId',
			headerFilterField: 'LanguageId',
			width: 200,
			headerFilter: true,
			standaloneHeaderFilter: true,
			readOnly: true,
			required: true,
			filterColSize: 4,
			lookup: 'Language',
			headerFilterSiblingComponents: [
				({ navigate }) => (
					<ActionIconButton
						color="success"
						onClick={() => navigate('/languagelist')}
						variant="contained"
						sx={{
							ml: 1
						}}
					>
						<FormatListBulletedTwoToneIcon />
					</ActionIconButton>
				)
			],
			onClose: () => { } //Validation Override
		},
		{ field: 'LanguageDetailId', header: 'UniqueId', keyColumn: true, hidden: true, width: 200, isNotformfield: true },
		{ field: 'DisplayValue', header: 'LanguageName', width: 200, isNotformfield: true },
		{
			header: 'LanguageKey',
			field: 'LanguageKeyName',
			width: 200,
			required: true,
			readOnly: true,
			customizeInput: ({ Input, inputProps }) => (
				<Input
					{...inputProps}
					otherProps={{
						...inputProps?.otherProps,
						disabled: true
					}}
				/>
			)
		},
		{ field: 'LanguageValue', width: 200, required: true }
	]
});

export default model.createFormBase();